/**
 * 將 HTML 字串進行消毒，移除可能的 XSS 攻擊
 * 使用 sanitize-html 來確保在瀏覽器和 Node.js 環境中都能正常運作。
 * @param {string} [html] - 要消毒的 HTML 字串。
 * @returns {string} 消毒後的 HTML 字串。
 */

import sanitizeHtml from 'sanitize-html';

const provideSanitized = (html?: string): string => {
  return sanitizeHtml(html ?? '', {
    allowedAttributes: {
      ...sanitizeHtml.defaults.allowedAttributes,
      a: [...(sanitizeHtml.defaults.allowedAttributes.a ?? []), 'class'],
      span: ['class'],
    },
  });
};

export default provideSanitized;
